module.exports = __webpack_public_path__ + "static/media/uploadInvoice.3edb514f.svg";